import PropTypes from 'prop-types';
import React, { Component } from 'react';
import * as Colors from 'material-ui/styles/colors';
import Paper from 'material-ui/Paper';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import { Link } from 'react-router';
import * as routes from 'App/routeConstants';
import { connect } from 'react-redux';
import { EDITOR_MODES } from 'crazyEditor/core/constants/editorConstants';
import shallowEqual from 'fbjs/lib/shallowEqual';
import ChildrenFader from 'shared/components/ChildrenFader';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import connectWithRouter from 'shared/components/redux/connectWithRouter';

const styles = {
  editButton: {
    width: '100%',
    backgroundColor: Colors.white,
    borderRadius: 0,
    display: 'flex',
    height: 55,
    lineHeight: '55px'
  },
  previewButton: {
    cursor: 'zoom-in',
    width: '100%',
    height: '100%',
    backgroundColor: Colors.transparent,
  },
};

@connectWithRouter(
  state => ({
    query: state.routing.location.query,
  })
)
export default class DesignPreview extends Component {

  state = {
    hover: false,
  };

  shouldComponentUpdate(nextProps, nextState) {
    return !(shallowEqual(this.props, nextProps) && shallowEqual(this.state, nextState));
  }

  render() {
    const {template, query, width, height} = this.props;
    const {hover} = this.state;
    return (
      <div>
      <Paper style = {{
        backgroundImage: `url("${template.previewUrl}")`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        height: height,
        width: width,
        transitionDuration: 250,
      }}
             onMouseEnter = {() => this.setState({hover: true})}
             onMouseLeave = {() => this.setState({hover: false})}
             zDepth = {hover ? 2 : 1}
      >
        <div
          style={{width: '100%', height: '100%', overflow: 'hidden', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end'}}
        >
        {
          (hover) &&
          <FlatButton
            style={styles.previewButton}
            containerElement={<Link
              to={{pathname: routes.Editor.TemplateURL, query: {...query, id: template.id, mode: EDITOR_MODES.QUICK_PREVIEW}}}
            />}
          />
        }
        <ChildrenFader
          visible={hover}
          transitionDurationMs={250}
          style={{width: '100%'}}
          hiddenStyle={{transform: 'translateY(100%)'}}
        >
          <RaisedButton
            style={styles.editButton}
            label = "edit"
            icon={<EditIcon/>}
            containerElement={<Link to={{pathname: routes.Editor.TemplateURL, query: {...query, id: template.id}}} />}
          />
        </ChildrenFader>
          </div>
      </Paper>
        <div style = {{
          marginTop: 8,
          color: Colors.grey700,
        }}>
          {template.name}
        </div>
      </div>
    );
  }
}